import styled from 'styled-components';
import { OptionsSelectStyled } from '../OptionsSelectStyled';
import { rem } from 'polished';

export const OptionsSelectStyledDS = styled(OptionsSelectStyled)`
    .option-list {
        .isSelected {
            border-color: ${({ theme }) => theme.colors.secondary} !important;
            background-color: ${({ theme }) => theme.colors.grey4};
        }

        border-bottom: 1px solid ${({ theme }) => theme.colors.grey16};
        padding-bottom: ${rem(15)};
    }

    .optionsTriggerWrapper > span {
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
        font-size: ${({ theme }) => theme.fontSizes.h5};
    }

    .option-card__name .checkbox .checkboxWrapper label::before {
        transform: rotate(90deg);
    }

    .selectedOptions {
        width: ${rem(22)};
        height: ${rem(22)};
        border-radius: 50%;
    }
`;
